<template>
  <div>
    <Breadcrumb :key="$route.path" />
    <div class="container-fluid bgc-container">
      <div class="row successfull mt-2">
        <div class="col">
          <img
            src="@/assets/images/group-3-copy-3@3x.png"
            class="done-logo"
            alt="done"
          />
        </div>
      </div>
      <!-- Thank You -->
      <div class="row">
        <div class="col text-center">
          <p class="thank-you mt-3 mb-3">Thank You !</p>
          <p class="mt-4 mb-2" id="cancel_request" v-if="!stp">
            Cancellation Request Submitted! Your Cancellation Request for Policy
            Number <b><span class="policy-no">{{policyNo}}</span></b
            >&nbsp; has been referred to the Underwriter.
          </p>
          <p class="mt-4 mb-2" id="cancel_request" v-if="stp">
            Cancellation letter <span class="policy-no">{{cancellationNo}}</span> has been generated successfully for Policy
            Number <b><span class="policy-no">{{policyNo}}</span></b
            >&nbsp;<br>
          </p>
          <p><b>Refund for <span class="policy-no">₹{{refundAmount}}</span> is expected.</b></p>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <button
            type="button"
            id="done"
            class="btn bgc-btn-primary float-right my-5"
            data-dismiss="modal"
            @click="goToPolicySearch()"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import { reactive } from "@vue/composition-api";
export default {
  name: "CancellationSuccess",
  props: ['stp','policyNo','cancellationNo','refundAmount'],
  components: {
    Breadcrumb,
  },
   setup(props,context) {
    let state = reactive({});
    // method
    function goToPolicySearch(){
      window.location = context.root.$store.state.bagic.globalConfiguration['baseUrl']+'/policySearch/Cancel';
    }
    return {
      state,
      goToPolicySearch
    };
  },
};
</script>

<style scoped>
.done-logo {
  margin-top: 24px;
  text-align: center;
}
.policy-no {
  font-weight: bold;
  color: #0070be;
}
.successfull {
  text-align: center;
}
.thank-you {
  font-size: 30px;
  color: #333333;
}
.btn:hover {
  color: #ffffff;
}
@media (max-width: 575px) {
  .thank-you {
    font-size: 24px;
  }
}
</style>
